import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from '../locales/en.json'
import ro from '../locales/ro.json'

/** Supported languages */
export type Language = 'en' | 'ro'

/** Language configuration */
export interface LanguageConfig {
  code: Language
  name: string
  nativeName: string
}

/** Available languages */
export const languages: LanguageConfig[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ro', name: 'Romanian', nativeName: 'Romana' }
]

/** Default language */
export const defaultLanguage: Language = 'en'

/** LocalStorage key for language preference */
export const LANGUAGE_STORAGE_KEY = 'petru-language'

/**
 * Get initial language from localStorage or browser settings
 */
function getInitialLanguage(): Language {
  if (typeof window === 'undefined') return defaultLanguage

  // Check localStorage first
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY)
  if (stored === 'en' || stored === 'ro') {
    return stored
  }

  // Fall back to browser language
  const browserLang = navigator.language.split('-')[0]
  if (browserLang === 'ro') {
    return 'ro'
  }

  return defaultLanguage
}

/** Translation resources */
const resources = {
  en: {
    translation: en
  },
  ro: {
    translation: ro
  }
}

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: defaultLanguage,
    interpolation: {
      escapeValue: false // React already escapes values
    },
    react: {
      useSuspense: false // Disable suspense for SSR compatibility
    }
  })

export default i18n
